import React from 'react';
import { Sparkles, Code, BookOpen, Lightbulb, PenTool, Globe, Calculator, Microscope } from 'lucide-react';

const suggestions = [
  {
    icon: Code,
    label: 'Kod Yaz',
    color: 'from-blue-500 to-cyan-500',
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    border: 'border-blue-200 dark:border-blue-800',
    prompt: 'Python ile basit bir web scraper yaz ve adım adım açıkla',
  },
  {
    icon: BookOpen,
    label: 'Öğren',
    color: 'from-purple-500 to-pink-500',
    bg: 'bg-purple-50 dark:bg-purple-900/20',
    border: 'border-purple-200 dark:border-purple-800',
    prompt: 'Yapay zeka nedir? Temel kavramları ve kullanım alanlarını açıkla',
  },
  {
    icon: PenTool,
    label: 'Yaratıcı Yaz',
    color: 'from-orange-500 to-red-500',
    bg: 'bg-orange-50 dark:bg-orange-900/20',
    border: 'border-orange-200 dark:border-orange-800',
    prompt: 'İstanbul hakkında kısa ve etkileyici bir şiir yaz',
  },
  {
    icon: Lightbulb,
    label: 'Fikir Üret',
    color: 'from-amber-500 to-yellow-500',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    border: 'border-amber-200 dark:border-amber-800',
    prompt: 'Üniversite öğrencileri için yenilikçi bir mobil uygulama fikri öner',
  },
  {
    icon: Globe,
    label: 'Araştır',
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    border: 'border-emerald-200 dark:border-emerald-800',
    prompt: 'Türkiye ekonomisinin 2025 yılı değerlendirmesini yap',
  },
  {
    icon: Calculator,
    label: 'Hesapla',
    color: 'from-indigo-500 to-violet-500',
    bg: 'bg-indigo-50 dark:bg-indigo-900/20',
    border: 'border-indigo-200 dark:border-indigo-800',
    prompt: 'Aylık 15.000 TL gelirle bütçe planı oluştur',
  },
];

const EmptyState = React.memo(({ onSuggestionClick }) => {
  return (
    <div className="flex-1 flex items-center justify-center p-6 min-h-[60vh]">
      <div className="max-w-2xl w-full space-y-8">
        {/* Logo & Title */}
        <div className="text-center space-y-3">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-600 to-red-500 shadow-lg shadow-purple-500/20 mb-2">
            <Sparkles className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            Merhaba, ben Zeha AI
          </h1>
          <p className="text-base text-gray-500 dark:text-gray-400 max-w-md mx-auto">
            Soru sor, araştırma yap, kod yaz, yaratıcı içerik üret — her konuda yanındayım.
          </p>
        </div>

        {/* Suggestion Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {suggestions.map((s) => {
            const Icon = s.icon;
            return (
              <button
                key={s.label}
                onClick={() => onSuggestionClick && onSuggestionClick(s.prompt)}
                className={`group relative flex flex-col items-start gap-2 p-4 rounded-xl border ${s.border} ${s.bg} hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 text-left cursor-pointer`}
              >
                <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${s.color} flex items-center justify-center shadow-sm`}>
                  <Icon className="w-4.5 h-4.5 text-white" />
                </div>
                <span className="text-sm font-semibold text-gray-800 dark:text-gray-200">{s.label}</span>
                <span className="text-[11px] text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed">{s.prompt}</span>
              </button>
            );
          })}
        </div>

        {/* Footer tip */}
        <p className="text-center text-xs text-gray-400 dark:text-gray-500">
          💡 Bir kart seç veya aşağıdaki alana istediğini yaz
        </p>
      </div>
    </div>
  );
});

EmptyState.displayName = 'EmptyState';

export default EmptyState;
